import Link from "next/link";

import useSignInUrl from "@/users/useSignInUrl";
import ErrorMessage from "../ErrorMessage";

const NotLoggedInError = () => {
  const signInUrl = useSignInUrl();
  return (
    <ErrorMessage headline="You are not logged in.">
      <span>Please </span>
      <Link href={signInUrl}>log in</Link>
      <span> and you will be redirected back to this page.</span>
    </ErrorMessage>
  );
};

export default NotLoggedInError;
